class ProductIngredients {
  constructor(section) {
    this.container = section;
    this.ingredients = this.container.querySelectorAll('.ingredient-list__item');
    this.bindEvents();
    this.initCarousel(); // Initialize the carousel
    this.currentIngredientIndex = 0; // Track the current ingredient index
  }

  initCarousel() {
    const carouselElement = this.container.querySelector('carousel-slider');
    if (carouselElement) {
      // Initialize the carousel
      new CarouselSlider(carouselElement);
    }
  }

  bindEvents() {
    this.ingredients.forEach((ingredient, index) => {
      ingredient.addEventListener('click', () => this.showIngredientInfo(index));
    });
  }

  showIngredientInfo(index) {
    this.currentIngredientIndex = index; // Update the current index
    const ingredient = this.ingredients[index];
    const name = ingredient.dataset.ingredientName;
    const description = ingredient.dataset.ingredientDescription;

    const modalId = `modal-ingredient_ingredient_${ingredient.dataset.modalId}`;
    const modal = document.querySelector(`#${modalId}`);

    if (!modal) {
      console.error(`Modal with ID ${modalId} not found.`);
      return;
    }

    modal.querySelector('.ingredient-modal__title').textContent = name;
    modal.querySelector('.ingredient-modal__description').innerHTML = description;

    // Save the current scroll position
    const scrollY = window.scrollY;
    modal.setAttribute('open', 'true'); // Add open attribute
    document.body.style.overflow = 'hidden'; // Prevent body scroll
    document.body.style.position = 'fixed'; // Fix body position
    document.body.style.top = `-${scrollY}px`; // Set top to current scroll position

    // Close modal when clicking outside of the modal content
    const outsideClickListener = (event) => {
      if (!modal.querySelector('.modal__content').contains(event.target)) {
        this.closeModal(modal, scrollY);
      }
    };

    modal.addEventListener('click', outsideClickListener);

    // Close button functionality
    modal.querySelector('.modal__close-btn').addEventListener('click', (e) => {
      e.preventDefault(); // Prevent default action
      this.closeModal(modal, scrollY);
    });

    // Next and Previous button functionality
    modal.querySelector('.modal__next-btn').addEventListener('click', (e) => {
      e.preventDefault();
      this.showNextIngredient(modal);
    });

    modal.querySelector('.modal__prev-btn').addEventListener('click', (e) => {
      e.preventDefault();
      this.showPrevIngredient(modal);
    });
  }

  showNextIngredient(modal) {
    this.currentIngredientIndex = (this.currentIngredientIndex + 1) % this.ingredients.length; // Loop back to the first ingredient
    this.updateModalContent(modal);
  }

  showPrevIngredient(modal) {
    this.currentIngredientIndex = (this.currentIngredientIndex - 1 + this.ingredients.length) % this.ingredients.length; // Loop back to the last ingredient
    this.updateModalContent(modal);
  }

  updateModalContent(modal) {
    const ingredient = this.ingredients[this.currentIngredientIndex];
    const name = ingredient.dataset.ingredientName;
    const description = ingredient.dataset.ingredientDescription;

    modal.querySelector('.ingredient-modal__title').textContent = name;
    modal.querySelector('.ingredient-modal__description').innerHTML = description;
  }

  closeModal(modal, scrollY) {
    modal.removeAttribute('open'); // Remove open attribute
    document.body.style.overflow = ''; // Restore body overflow
    document.body.style.position = ''; // Reset body position
    document.body.style.top = ''; // Reset top
    window.scrollTo(0, scrollY); // Restore scroll position
    modal.classList.remove('is-active'); // Remove active class
  }
}

// Initialize the section
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('cc-product-ingredients')) {
    new ProductIngredients(event.target);
  }
});

// Initialize existing sections on page load
document.querySelectorAll('.cc-product-ingredients').forEach((section) => {
  new ProductIngredients(section);
});
